import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

//CUSTOM COMPONENTS
import Elemts from '../common/elemts/elemts';
import Dropimage from '../common/dropimage';

//options
const editable = true;

const Editor = props => {
	const [error, setError] = useState(false);
	const [categorias, setCategorias] = useState([]);

	//ELEMENTOS LISTA
	const [elemts, setElements] = useState(
		[{ "order": 0, "key": 0, "data": {}, "title": "Descripcion" }]
	);

	//DATOS DE LA NOTICIA
	const [data, setData] = useState({
		titulo: '',
		categoria: [],
		portada: {},
		fuente: '',
		etiquetas: '',
	});

	//validacion
	const val = {
		titulo: error && data.titulo === '',
		categoria: error && data.categoria === '',
		portada: error && (data.portada.base ? data.portada.base === '' : true),
		fuente: error && data.fuente === '',
		etiquetas: error && data.etiquetas === '',
	}

	//CONSULTAR CATEGORIAS
	const getCategorias = async () => {
		let response = await fetch('/p_categorias', {
			method: 'GET',
		});
		try {
			let res = await response.json();
			var new_res=res.filter(x=>(x.NOMBRE!=='¿Sabías qué?') && x)
			setCategorias(new_res);
		}
		catch(err){
			console.log('El error',err)
		}
	}

	useEffect(() => {
		getCategorias();
	}, []);

	//CAMBIOS NOTICIAS
	const set = (name, value) => {
		if (name !== 'elemts') {
			var temp = data;
			temp[name] = value;
			setData({
				titulo: temp.titulo,
				categoria: temp.categoria,
				portada: temp.portada,
				etiquetas: temp.etiquetas,
				fuente: temp.fuente,
			});
		}
		else {
			setElements([...value]);
		}
	}

	let lock = true;

	//GUARDAR NOTICIA
	const guardar = async () => {
		console.log('El data',data)
		var flag = (data.titulo !== ''
			&& data.categoria.length > 0
			&& data.portada.base ? data.portada.base !== '' : false
			&& data.fuente !== ''
			&& data.etiquetas !== ''
		);
		console.log('flag',flag,'lock',lock)
		if (flag && lock) {
			const toastId = toast.warn('Guardando...', { autoClose: 10000 });
			lock = false;
			const data_send = {
				titulo: data.titulo,
				idcategoria: data.categoria[0].ID,
				portada: data.portada.base,
				etiquetas: data.etiquetas,
				fuente: data.fuente,
				autor: localStorage.getItem('id_usr'),
			}
			console.log('Datos',data_send,'Elementos',elemts)
			fetch('/p_cotidiano', {
				method: 'POST',
				body: JSON.stringify({
					data: data_send,
					elementos: elemts
				}),
				headers: { 'Content-Type': 'application/json' }
			})
			.then(res=>res.json())
			.then(res=>{
				console.log(res)
				lock = true;
				toast.dismiss(toastId.current);
				toast.success('Guardado!!',{autoClose: 1500})
				setTimeout(() => props.history.push('/cotidiano'), 1500)
			})
			.catch(err=>{
				console.log(err)
				lock = true;
				toast.dismiss(toastId.current);
				setTimeout(() => toast.warn('Error...'), 1500)
			})
		}
		else{
			setError(true);
			setTimeout(() => toast.warn('No puedes dejar campos vacíos.'), 1500)
		}
	}

	return (
		<Fragment>
			<Breadcrumb title="Crear Nota Cotidiana" parent="Cotidiano" />
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12" >
						<Formulario noticia={data} set={set} list={{ categorias }} val={val} />
						<Elemts noticia={elemts} set={set} editable={editable} guardar={guardar}/>
					</div>
				</div>
			</div>
		</Fragment>
	);
}

const Formulario = props => {
	const { categorias } = props.list;
	const { val } = props;
	const noticia = props.noticia;
	const set = e => { props.set(e.target.name, e.target.value) }

	return (
		<Fragment>
			<div className="card mt-2">
				<div className="card-body">

					<div className="form-row" >
						{/* INPUT PORTADA */}
						<div className="col-md-4 mb-3">
							<label>Portada</label>
							<Dropimage
								imagen={noticia.portada}
								onUpload={val => props.set('portada', val)}
								// maxSize={307200}
							/>
							<span className="error text-danger">
								{val.portada ? 'Seleccione una portada' : ''}
							</span>
						</div>
						<div className="col-md-8 mb-3">
							<div className="form-row" >
								{/* INPUT TITULO */}
								<div className="col-md-12 mb-3">
									<label>Título</label>
									<input
										className="form-control"
										name="titulo"
										type="text"
										autoComplete="off"
										placeholder="Título..."
										value={noticia.titulo}
										onChange={set}
									/>
									<span className="error text-danger">
										{val.titulo ? 'Ingresa el titulo' : ''}
									</span>
								</div>
								{/* INPUT CATEGORIA */}
								<div className="col-md-12 mb-3">
									<label>Categoría</label>
									<Typeahead
										id="c-typeahead"
										placeholder="Categoría..."
										options={categorias}
										labelKey="NOMBRE"
										defaultSelected={noticia.categoria}
										onChange={val => props.set('categoria', val)}
										renderMenuItemChildren={(option) => {
											return [
												<div key="NOMBRE" >
													{option.NOMBRE}
												</div>
											];
										}}
									/>
									<span className="error text-danger">
										{val.categoria ? 'Seleccione una categoría' : ''}
									</span>
								</div>
							</div>

						</div>
					</div>

					<div className="form-row">
						{/* INPUT FUENTE */}
						<div className="col-md-6 mb-3">
							<label>Fuente</label>
							<input
								className="form-control"
								name="fuente"
								type="text"
								autoComplete="off"
								placeholder="Fuente..."
								value={noticia.fuente}
								onChange={set}
							/>
							<span className="error text-danger">
								{val.fuente ? 'Ingrese la fuente' : ''}
							</span>
						</div>
						<div className="col-md-6 mb-3">
							<label>Etiquetas</label>
							<input
								className="form-control"
								name="etiquetas"
								type="text"
								autoComplete="off"
								placeholder="Etiquetas..."
								value={noticia.etiquetas}
								onChange={set}
							/>
							<span className="error text-danger">
								{val.etiquetas ? 'Ingrese la etiqueta' : ''}
							</span>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default Editor;